export const scripts = {
  "nl": {
    languageLabel: "Dutch",
    load: async () => (await import("virtual:script/nl")).default,
  },
  "en": {
    languageLabel: "English",
    load: async () => (await import("virtual:script/en")).default,
  }
};